import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzPt1 } from './pages'

type TIdToPageMapWoofzPt1 = Record<PageIdWoofzPt1, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_PT1: TIdToPageMapWoofzPt1 = {
  [PageIdWoofzPt1.DOG_SEX_PT1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1/pages/questions/DogSexQuestion').then(
        (m) => ({
          default: m.DogSexQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/questions/DogSexQuestion'),
  },
  [PageIdWoofzPt1.DOG_AGE_PT1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1/pages/questions/DogAgeQuestion').then(
        (m) => ({
          default: m.DogAgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/questions/DogAgeQuestion'),
  },
  [PageIdWoofzPt1.SHELTER_PT1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1/pages/questions/DogShelterQuestion').then(
        (m) => ({
          default: m.DogShelterQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/questions/DogShelterQuestion'),
  },
  [PageIdWoofzPt1.DOG_BREED_PT1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pt1/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  [PageIdWoofzPt1.URGE_PT1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1/pages/urge/UrgePagePT').then((m) => ({
        default: m.UrgePagePT,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pt1/pages/urge/UrgePagePT'),
  },
  [PageIdWoofzPt1.STARTED_PT1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1/pages/questions/StartedPTQuestion').then(
        (m) => ({
          default: m.StartedPTQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/questions/StartedPTQuestion'),
  },
  [PageIdWoofzPt1.PLACE_PT1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1/pages/questions/PottyPlaceQuestion').then(
        (m) => ({
          default: m.PlacePTQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/questions/PottyPlaceQuestion'),
  },
  [PageIdWoofzPt1.GOALS_PT1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1/pages/questions/GoalsQuestion').then(
        (m) => ({
          default: m.GoalsQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/questions/GoalsQuestion'),
  },
  [PageIdWoofzPt1.ACCIDENTS_PT1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1/pages/questions/DogAccidentsQuestion'
      ).then((m) => ({
        default: m.DogAccidentsQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/questions/DogAccidentsQuestion'),
  },
  [PageIdWoofzPt1.CONCERNS_PT1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1/pages/questions/ConcernsQuestion').then(
        (m) => ({
          default: m.ConcernsQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/questions/ConcernsQuestion'),
  },
  [PageIdWoofzPt1.URGE_2_PT1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1/pages/urge/UrgePagePTVariant2').then(
        (m) => ({
          default: m.UrgePagePT2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/urge/UrgePagePTVariant2'),
  },
  [PageIdWoofzPt1.LIVING_SITUATION_PT1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1/pages/questions/LivingSituationQuestion'
      ).then((m) => ({
        default: m.LivingSituationQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/questions/LivingSituationQuestion'),
  },
  [PageIdWoofzPt1.POTTY_BREAKS_PT1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1/pages/questions/OutsidePottyBreaksQuestion'
      ).then((m) => ({
        default: m.PottyBreaksQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pt1/pages/questions/OutsidePottyBreaksQuestion'
      ),
  },
  [PageIdWoofzPt1.CRATE_TRAINING_PT1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1/pages/questions/CrateTrainingQuestion'
      ).then((m) => ({
        default: m.CrateTrainingQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/questions/CrateTrainingQuestion'),
  },
  [PageIdWoofzPt1.BEHAVIOR_PT1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1/pages/questions/BehaviorQuestion').then(
        (m) => ({
          default: m.BehaviorQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/questions/BehaviorQuestion'),
  },
  [PageIdWoofzPt1.COMMANDS_PT1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1/pages/questions/DogCommands').then(
        (m) => ({
          default: m.DogCommands,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/questions/DogCommands'),
  },
  [PageIdWoofzPt1.TRAINING_TIME_PT1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1/pages/questions/TrainingTimeQuestion'
      ).then((m) => ({
        default: m.TrainingTimeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/questions/TrainingTimeQuestion'),
  },
  [PageIdWoofzPt1.PREPARE_FLOW_PT1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1/pages/prepareFlow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdWoofzPt1.COMMITMENT_SCREEN_PT1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1/pages/urge/WoofzCommitment').then(
        (m) => ({
          default: m.WoofzCommitment,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_pt1/pages/urge/WoofzCommitment'),
  },
  [PageIdWoofzPt1.EMAIL_PT1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1/pages/email/EmailVariantPT').then(
        (m) => ({
          default: m.EmailVariantPT,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_pt1/pages/email/EmailVariantPT'),
  },
  [PageIdWoofzPt1.NEWSLETTER_URGE_PT1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1/pages/email/NewsletterUrge').then(
        (m) => ({
          default: m.NewsletterUrge,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_pt1/pages/email/NewsletterUrge'),
  },
  [PageIdWoofzPt1.SUBSCRIPTIONS_PT1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1/pages/subscriptions/SubscriptionsPage'
      ).then((m) => ({
        default: m.SubscriptionsPage,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/subscriptions/SubscriptionsPage'),
  },
  [PageIdWoofzPt1.CANCEL_OFFER_PT1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1/pages/subscriptions/CancelOfferVariantPT'
      ).then((m) => ({
        default: m.CancelOfferVariantPT,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pt1/pages/subscriptions/CancelOfferVariantPT'
      ),
  },
  [PageIdWoofzPt1.CHAT_UPSELL_PT1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzPt1.UPSELL_PT1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pt1/pages/upsell/Upsell'),
  },
  [PageIdWoofzPt1.UPSELL_FEEDING_GUIDE_PT1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1/pages/upsell/FeedingGuideUpsell').then(
        (m) => ({
          default: m.FeedingGuideUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/upsell/FeedingGuideUpsell'),
  },
  [PageIdWoofzPt1.UPSELL_EMOTIONAL_SUPPORT_PT1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1/pages/upsell/EmotionalSupportUpsell'
      ).then((m) => ({
        default: m.EmotionalSupportUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/upsell/EmotionalSupportUpsell'),
  },
  [PageIdWoofzPt1.DOWNLOAD_PT1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1/pages/download-app/DownloadApp'),
  },
  [PageIdWoofzPt1.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
